// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../../assets/portal/js/" + chunkId + "." + {"234":"8e8d4a51","475":"0aac79ad"}[chunkId] + ".js";
};